import { NgModule } from '@angular/core';

import { CommonButtonFilledDirective } from './button-filled.directive';
import { CommonButtonIconDirective } from './button-icon.directive';
import { CommonButtonOutlinedDirective } from './button-outlined.directive';

const buttons = [
	CommonButtonIconDirective,
	CommonButtonFilledDirective,
	CommonButtonOutlinedDirective,
];

/**
 * @deprecated Use `ButtonsModule` from 'ui/buttons' instead.
 */
@NgModule({
	imports: [...buttons],
	exports: [...buttons],
})
export class CommonButtonsModule {}
